import React from 'react';
import type { ProgressBarProps } from './ProgressBar.types';

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max,
  intent = 'success',
  className,
}) => {
  const percentage = Math.min((value / max) * 100, 100); // Cap at 100%
  const getBackgroundColor = () => {
    if (intent === 'success') return 'var(--bg-success)';
    if (intent === 'warning') return 'var(--bg-caution)';
    if (intent === 'info') return 'var(--bg-accent)';
    if (intent === 'disabled') return 'var(--bg-disabled)';
    return 'var(--bg-critical)';
  };

  return (
    // Nit: This component should use a progress element to be accessible. TODO @chris
    <div
      className={className}
      style={{
        width: '100%',
        backgroundColor: '#e0e0e0',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${percentage}%`,
          backgroundColor: getBackgroundColor(),
          height: '8px',
        }}
      />
    </div>
  );
};
